import { update } from "lodash";
import * as actions from "./actionType";

export const fetchAgItemList = (payload) => ({
  type: actions.FETCH_AG_ITEM_LIST,
  payload,
});

export const fetchAgItemListSuccess = (payload) => ({
  type: actions.FETCH_AG_ITEM_LIST_SUCCESS,
  payload,
});

export const fetchAgItemQuestions = (payload) => ({
  type: actions.FETCH_AG_ITEM_QUESTIONS,
  payload,
});

export const fetchAgItemQuestionsSuccess = (payload) => ({
  type: actions.FETCH_AG_ITEM_QUESTIONS_SUCCESS,
  payload,
});

export const fetchAgQuestionResponses = (payload) => ({
  type: actions.FETCH_AG_QUESTION_RESPONSES,
  payload,
});

export const fetchAgQuestionResponsesSuccess = (payload) => ({
  type: actions.FETCH_AG_QUESTION_RESPONSES_SUCCESS,
  payload,
});

export const fetchResponseComments = (payload) => ({
  type: actions.FETCH_RESPONSE_COMMENTS,
  payload,
});

export const featchResponseCommentsSuccess = (payload) => ({
  type: actions.FETCH_RESPONSE_COMMENTS_SUCCESS,
  payload,
});

export const submitUserResponse = (payload) => ({
  type: actions.SUBMIT_USER_FEEDBACK,
  payload,
});

export const submitUserResponseSuccess = (payload) => ({
  type: actions.SUBMIT_USER_FEEDBACK_SUCCESS,
  payload,
});

export const updateSelectedResource = (payload) => ({
  type: actions.UPDATE_SELECTED_RESOURCE,
  payload,
});

export const resetSelectedResource = () => ({
  type: actions.RESET_SELECTED_RESOURCE,
});

export const updateNavigatorState = (payload) => ({
  type: actions.UPDATE_NAVIGATOR_STATE,
  payload,
});

export const updateSelectedQuestionIndex = (payload) => ({
  type: actions.UPDATE_SELECTED_QUESTION_INDEX,
  payload,
});
